import { render, staticRenderFns } from "./ExpensesBulkCreation.vue?vue&type=template&id=4b874d8d&"
import script from "./ExpensesBulkCreation.vue?vue&type=script&lang=js&"
export * from "./ExpensesBulkCreation.vue?vue&type=script&lang=js&"
import style0 from "./ExpensesBulkCreation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports